import type { EdgeFunctionCountryLookupResponse } from "@babybjorn/netlify-edge-functions";
import { addBreadcrumb } from "@sentry/gatsby";
import { fetchEdgeFunction } from "../../utils/edge-functions";
import { isResponse } from "../type-guards/general";

export const getUserLocation = async (): Promise<string | undefined> => {
	try {
		const timeout = new Promise<{ country: string } | undefined>(
			(_, reject) => {
				setTimeout(() => {
					reject(new Error("Request timed out"));
				}, 2000);
			},
		);

		const promise = fetchEdgeFunction("/country-lookup");
		return await Promise.race([promise, timeout]).then(async (response) => {
			if (isResponse(response)) {
				const data =
					(await response.json()) as EdgeFunctionCountryLookupResponse;

				return data?.code;
			}
		});
	} catch (error) {
		console.error(error);

		// Add breadcrumb to Sentry, but do not throw error.
		addBreadcrumb({
			level: "error",
			message: "Failed to get user location from external service",
			data: {
				error: JSON.stringify(error),
			},
		});

		return undefined;
	}
};
